export const NO_RECENT_SEARCH = [{
    suggestion: 'You have no Recent History',
}];
export const MULTIPLE_RECENT_SEARCH_DELIMITER = '|';